module.exports = __webpack_public_path__ + "static/img/iconProduct.64918d2.png";